(function (factory) {
  const estimator = factory();
  if (typeof module !== 'undefined' && module.exports) module.exports = estimator;
  if (typeof document !== 'undefined') estimator.start();
})(function () {
  'use strict';
const {FABRICS,LENGTHS,WIDTHS,MAXIMUM_WIDTH,EDGES,RIDGELINE_LOOPS,YES_NO,SIDE_PULLS,GROUND_HARDWARE,GLOWIRE,STAKES,PATCH_KIT}=window.SLDEstimatorData.products["trail_duster_2"];
const TARP_SHARED=window.SLDEstimatorData.shared.tarps;
const CONTROLS=window.SLDEstimatorData.productControls.trailDuster2;

  const FIELD_LABELS = Object.freeze({
    'Fabric/Color * (required)': 'Fabric',
    'Length * (required)': 'Length',
    'Width * (required)': 'Width',
    'Tarp Edges * (required)': 'Edge',
    'Intermediate Ridgeline Tie Outs * (required)': 'Ridgeline Loops',
    'Bivy Loops * (required)': 'Bivy Loops',
    'Side Panel Pull Outs * (required)': 'Side Panel Pull Outs',
    'Ground Tie Outs * (required)': 'Ground Hardware',
    "Reflective Guyline Cord * (required)": 'Glowire',
    'Tent Stakes * (required)': 'Tent Stakes',
    'Patch Kit * (required)': 'Patch Kit'
  });

  

  

  

  

  

  

  

  

  

  

  
  const own = (object, key) => Object.prototype.hasOwnProperty.call(object, key);
  const exactText = (value) => String(value || '').trim();

  function selections(scope) {
    const selected = Object.create(null);
    for (const element of scope.querySelectorAll('select')) {
      const label=Object.keys(FIELD_LABELS).find(key=>key.replace(/\s+/g,' ').trim()===String(element.labels&&element.labels[0]&&element.labels[0].textContent||'').replace(/\s+/g,' ').trim());
      if (!own(FIELD_LABELS, label)) continue;
      selected[FIELD_LABELS[label]] = exactText(element.value);
    }
    return selected;
  }

  function sackWeight(areaSqIn,isSilpoly16=false,poleCount=0){return TARP_SHARED.mainSackWeight(areaSqIn,isSilpoly16,poleCount);}

  function resolvedWidth(value, fabric) {
    if (value === MAXIMUM_WIDTH) return fabric.maximumWidth;
    return WIDTHS[value];
  }

  function estimate(choice) {
    if (
      choice.Fabric === 'Custom Fabric (Please Contact Me First)' ||
      choice.Width === 'Custom (Please Contact Me First)'
    ) return { manual: true };

    const fabric = FABRICS[choice.Fabric];
    const length = LENGTHS[choice.Length];
    const edge = EDGES[choice.Edge];
    const ridgelineLoops = RIDGELINE_LOOPS[choice['Ridgeline Loops']];
    const bivyLoops = YES_NO[choice['Bivy Loops']];
    const sideChoice = choice['Side Panel Pull Outs'];
    const sidePulls = Object.prototype.hasOwnProperty.call(SIDE_PULLS, sideChoice) ? SIDE_PULLS[sideChoice] : undefined;
    const hardware = GROUND_HARDWARE[choice['Ground Hardware']];
    const glowire = GLOWIRE[choice.Glowire];
    const stakes = STAKES[choice['Tent Stakes']];
    const patchKit = PATCH_KIT[choice['Patch Kit']];

    if (
      !fabric || !length || !edge || ridgelineLoops === undefined ||
      bivyLoops === undefined || sidePulls === undefined || !hardware ||
      glowire === undefined || stakes === undefined || patchKit === undefined
    ) return null;

    const width = resolvedWidth(choice.Width, fabric);
    if (!width) return choice.Width === MAXIMUM_WIDTH ? { invalid: true } : null;
    if (width > 112 && fabric.className !== 'wide') return { invalid: true };

    const rawLength = length * 12 + 3;
    const rawWidth = width + 6;
    const rawBody = rawLength * rawWidth / 1296 * fabric.density;
    const longEdgeDeflection = length <= 10 ? 2.5 : 3;
    const endEdgeDeflection = width <= 96 ? 2.5 : 3;
    const catenaryArea = edge.catenary
      ? length * 12 * longEdgeDeflection + width * endEdgeDeflection
      : 0;
    const body = rawBody - catenaryArea / 1296 * fabric.density;
    const reinforcement = CONTROLS.baseReinforcement + (edge.extraTieOuts ? CONTROLS.extraReinforcementBackpacking : 0);
    const sideTieCount = edge.extraTieOuts ? 10 : 2;
    const tieAssemblies = 2 * hardware.ridge + 4 * hardware.corner + sideTieCount * hardware.side;
    const installedBivyLoops = bivyLoops ? CONTROLS.bivyLoopPair : 0;
    const installedRidgelineLoops = ridgelineLoops * CONTROLS.ridgelineLoopEach;
    const installedSidePulls = sidePulls === 'webbingLoops' ? 4 * TARP_SHARED.sidePulls.webbingLoopEach : sidePulls ? TARP_SHARED.sidePulls.assemblySet : 0;
    const seamSealing = length * TARP_SHARED.twoPanelSeam.baseSealPerFoot + (sidePulls ? TARP_SHARED.sidePulls.sealIncrement : 0);
    const finished = body + reinforcement + TARP_SHARED.twoPanelSeam.hemThread + tieAssemblies + installedBivyLoops +
      installedRidgelineLoops + installedSidePulls + seamSealing;
    const sack = sackWeight(rawLength * rawWidth - catenaryArea, choice.Fabric === 'Silpoly 1.6 (Choose from available solid colors at Ripstopbytheroll.com)', 0);
    const total = finished + sack + glowire + stakes + patchKit;

    return { body, finished, total, sack, width };
  }

  function start() {
    const root = document.querySelector('[data-sld-trail-duster-2-estimator]');
    if (!root) return;
    const scope = root.closest('product-info') || document;

    function calculate() {
      const result = estimate(selections(scope));
      const results = root.querySelector('[data-sld-estimator-results]');
      const message = root.querySelector('[data-sld-estimator-message]');

      if (!result || result.manual || result.invalid) {
        if (results) results.hidden = true;
        if (message) {
          message.textContent = result && result.manual
            ? 'Custom widths and fabrics require a manual weight estimate. Please contact me before ordering.'
            : result && result.invalid
              ? 'That width requires Xenon Sil Wide or Silpoly XL. Choose a compatible fabric or contact me for a custom estimate.'
              : 'Select your fabric, length, and width to see the estimated weight.';
        }
        return;
      }

      const tarpWeight = root.querySelector('[data-sld-weight-tarp]');
      const totalWeight = root.querySelector('[data-sld-weight-total]');
      if (tarpWeight) tarpWeight.textContent = result.finished.toFixed(1) + ' oz';
      if (totalWeight) totalWeight.textContent = result.total.toFixed(1) + ' oz';
      if (results) results.hidden = false;
      if (message) message.textContent = '';
    }

    let timer;
    const queue = () => {
      clearTimeout(timer);
      timer = setTimeout(calculate, 75);
    };
    document.addEventListener('change', queue, true);
    document.addEventListener('input', queue, true);
    document.addEventListener('click', queue, true);
    new MutationObserver(queue).observe(scope, {
      subtree: true,
      attributes: true,
      attributeFilter: ['value', 'checked', 'selected', 'class', 'aria-checked'],
      childList: true
    });
    calculate();
  }

  return { estimate, resolvedWidth, sackWeight, selections, start };
});
